import 'intl-tel-input/build/css/intlTelInput.css'
import 'intl-tel-input/build/js/intlTelInput'
import intlTelInput from 'intl-tel-input'

$.fn.form.settings.rules.vehicleLengthMax = function (value, maxLength) {
  // Testing the value is a number or decimal, not starting with 0
  // Valid value examples: 1, 4.2, 12, 12.1, 123.00, 12.12345, 12345.001
  // Invalid value examples: 01, 0.1, 012.1, 0.12345
  const reCorrectNumberFormat = new RegExp('^(?!0)\\d*\\.?\\d*$')
  const isCorrectNumberFormat = reCorrectNumberFormat.test(value.toLowerCase())
  const isLessThanMaxLength = parseFloat(value) <= parseFloat(maxLength)

  return isCorrectNumberFormat && isLessThanMaxLength
}
// Prompt if 'vehicleLengthMax' rule fails validation
$.fn.form.settings.prompt.vehicleLengthMax = 'Please enter a length that is less than {ruleValue} Metres'

$.fn.form.settings.rules.requiredVisible = function (value) {
  if ($(this).is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.checkoutAddressify = function (value) {
  if ($('.addressify-row').is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.dogEmpty = function (value) {
  if ($('.dog').is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.dogQuantity = function (value) {
  if ($('.dog').is(':visible')) {
    return parseFloat(value) >= 1
  }

  return true
}

$.fn.form.settings.rules.intPhone = function () {
  return $(this).data('validator').isValidNumber()
}

$.fn.form.settings.rules.alphanumericPlus = function (value) {
  const reg = new RegExp('^[\\w\\-\\s,()]+$')
  return reg.test(value)
}

$.fn.form.settings.rules.alphanumeric = function (value) {
  const reg = new RegExp('^[a-zA-Z][a-zA-Z0-9]*$')
  return reg.test(value)
}

$.fn.form.settings.rules.name = function (value) {
  const reg = new RegExp("^[a-zA-Z][a-zA-Z\\s\\-']*$")
  return reg.test(value)
}

$.fn.form.settings.rules.datePast = function (value) {
  if (!value) return false

  let now = new Date()
  let today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  let date = new Date(value)

  if (!(date instanceof Date && !isNaN(date))) {
    return false
  }

  return date >= today
}

$.fn.form.settings.rules.comparisonField = function () {
  let $ktcRadioChecked = $('.ktc-radio.ui.radio.checkbox.checked')

  if (
    $(this).attr('name').indexOf('TypeOfAnimal') > -1 &&
    $ktcRadioChecked.find('input[name*="PetsRequired"]').length
  ) {
    if (
      $(this).val().trim() === '' &&
      $ktcRadioChecked.find('input[name*="PetsRequired"]').val().toLowerCase() === 'yes'
    ) {
      return false
    }
  }

  if (
    $(this).attr('name').indexOf('OtherPursposeOfStay') > -1 &&
    $ktcRadioChecked.find('input[name*="PurposeOfStay"]').length
  ) {
    if (
      $(this).val().trim() === '' &&
      $ktcRadioChecked.find('input[name*="PurposeOfStay"]').val().toLowerCase() === 'other'
    ) {
      return false
    }
  }

  if (
    $(this).attr('name').indexOf('OtherEmploymentStatus') > -1 &&
    $ktcRadioChecked.find('input[name*="EmploymentStatus"]').length
  ) {
    if (
      $(this).val().trim() === '' &&
      $ktcRadioChecked.find('input[name*="EmploymentStatus"]').val().toLowerCase() === 'other'
    ) {
      return false
    }
  }

  return true
}

$.fn.form.settings.rules.checkedCheckbox = function () {
  return $(this).parent('span').attr('class').indexOf('checked') > -1
}

$.fn.form.settings.rules.msgLink = function (value) {
  let isValid = true
  const matches = value.match(/([a-zA-Z\d]+:\/\/)?((\w+:\w+@)?([a-zA-Z\d.-]+\.[A-Za-z]{2,4})(:\d+)?(\/.*)?)/g, value)

  if (matches) {
    for (let i = 0; i < matches.length; i++) {
      if (!(matches[i].indexOf('gdayparks.com.au') > -1 || matches[i].indexOf('gdaygroup.com.au') > -1)) {
        isValid = false
      }
    }
  }

  return isValid
}

$.fn.form.settings.rules.checkboxCount = function (value, checkboxCount) {
  return $(this).parent().find('input:checked').length >= parseInt(checkboxCount)
}

$.fn.form.settings.rules.rewardsPostage = function (value) {
  if ($('.member-form').is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.someoneElseEmpty = function (value) {
  if ($('.someone-else-form').is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.someoneElseIntPhone = function () {
  if ($('.someone-else-form').is(':visible')) {
    return $(this).data('validator').isValidNumber()
  }

  return true
}

$.fn.form.settings.rules.someoneElseManual = function (value) {
  if ($('.someone-else-form .manual-row').is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.someoneElseAddressify = function (value) {
  if ($('.someone-else-form .addressify-row').is(':visible')) {
    if (!value.length) return false
  }

  return true
}

$.fn.form.settings.rules.someoneElseEmailRegex = function (value) {
  if ($('.someone-else-form').is(':visible')) {
    if (!value.length) return true

    const reg = new RegExp(
      // eslint-disable-next-line no-control-regex
      "^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\\d|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-||_|~|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|\\d|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+|(([a-z]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+([a-z]+|\\d|-|\\.{0,1}|_|~|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])?([a-z]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))$",
    )
    return reg.test(value.toLowerCase())
  }

  return true
}

$.fn.form.settings.rules.someoneElseState = function (value) {
  if ($('.someone-else-form .manual-row').is(':visible')) {
    if ($('input[name="country"]').val().toLowerCase() === 'aus') {
      if (!value.length) return false
    }
  }

  return true
}

$.fn.form.settings.rules.customCreditCard = function (cardNumber, cardTypes) {
  console.log(cardNumber, cardTypes)

  let cards = {
      visa: {
        pattern: /^4/,
        length: [16],
      },
      amex: {
        pattern: /^3[47]/,
        length: [15],
      },
      mastercard: {
        pattern: /^5[1-5]/,
        length: [16],
      },
      discover: {
        pattern: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
        length: [16],
      },
      unionPay: {
        pattern: /^(62|88)/,
        length: [16, 17, 18, 19],
      },
      jcb: {
        pattern: /^35(2[89]|[3-8][0-9])/,
        length: [16],
      },
      maestro: {
        pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
      },
      dinersClub: {
        pattern: /^(30[0-5]|^36)/,
        length: [14],
      },
      laser: {
        pattern: /^(6304|670[69]|6771)/,
        length: [16, 17, 18, 19],
      },
      visaElectron: {
        pattern: /^(4026|417500|4508|4844|491([37]))/,
        length: [16],
      },
    },
    valid = {},
    validCard = false,
    requiredTypes = typeof cardTypes == 'string' ? cardTypes.split('|') : false,
    unionPay,
    validation

  if (typeof cardNumber !== 'string' || cardNumber.length === 0) {
    return
  }

  // allow dashes in card
  cardNumber = cardNumber.replace(/-/g, '')
  cardNumber = cardNumber.replace(/\s/g, '')

  // verify card types
  if (requiredTypes) {
    $.each(requiredTypes, function (index, type) {
      // verify each card type
      validation = cards[type]
      if (validation) {
        valid = {
          length: $.inArray(cardNumber.length, validation.length) !== -1,
          pattern: cardNumber.search(validation.pattern) !== -1,
        }
        if (valid.length && valid.pattern) {
          validCard = true
        }
      }
    })

    if (!validCard) {
      return false
    }
  }

  // skip luhn for UnionPay
  unionPay = {
    number: $.inArray(cardNumber.length, cards.unionPay.length) !== -1,
    pattern: cardNumber.search(cards.unionPay.pattern) !== -1,
  }
  if (unionPay.number && unionPay.pattern) {
    return true
  }

  // verify luhn, adapted from  <https://gist.github.com/2134376>
  let length = cardNumber.length,
    multiple = 0,
    producedValue = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
    ],
    sum = 0

  while (length--) {
    sum += producedValue[multiple][parseInt(cardNumber.charAt(length), 10)]
    multiple ^= 1
  }
  return sum % 10 === 0 && sum > 0
}

$.fn.form.settings.rules.acceptEmpty = function (value) {
  return value.length
}

$.fn.form.settings.rules.checkoutState = function (value) {
  if ($(this).parents('.manual-row').is(':visible')) {
    if ($(this).parents('.manual-row').find('input.country-input').val().toLowerCase() === 'aus') {
      if (!value.length) {
        return false
      }
    }
  }

  return true
}

$.fn.form.settings.rules.checkoutManual = function (value) {
  if ($(this).parents('.manual-row').is(':visible')) {
    if (!value.length) {
      return false
    }
  }

  return true
}

$.fn.form.settings.rules.postCode = function (value) {
  if ($(this).parents('.manual-row').is(':visible')) {
    // If country is Australia, accept only 4 numeric characters.
    if ($(this).parents('.manual-row').find('input.country-input').val().toLowerCase() === 'aus') {
      const reg = new RegExp('^[0-9]{4}$')
      return reg.test(value.toLowerCase())
    }

    // Otherwise, accept only free text up to 10 alphanumeric characters.
    const reg = new RegExp('^[a-zA-Z0-9 ]{1,10}$')
    return reg.test(value.toLowerCase())
  }

  return true
}

$.fn.form.settings.rules.emailRegex = function (value) {
  if (!value.length) {
    return true
  }

  const reg = new RegExp(
    // eslint-disable-next-line no-control-regex
    "^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\\d|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-||_|~|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|\\d|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+|(([a-z]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+([a-z]+|\\d|-|\\.{0,1}|_|~|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])?([a-z]|[\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))$",
  )

  return reg.test(value.toLowerCase())
}

$.fn.form.settings.rules.expiryDate = function (value) {
  // Is empty?
  if (!value.length) return false

  // Is test credit card expiry date? E.g. 99/00
  const reTestCardExpiryDateFormat = new RegExp('^([0-9]{2})[/]([0-9]{2})$')
  if (reTestCardExpiryDateFormat.test(value.toLowerCase())) {
    return true
  }

  // Is valid expiry date? E.g. 12/23
  const reExpiryDateFormat = new RegExp('^(0[1-9]|1[0-2])[/]([0-9]{2})$')
  return reExpiryDateFormat.test(value.toLowerCase())
}

$.fn.form.settings.rules.state = function (value) {
  if (!value.length) return true

  const reg = new RegExp('^(0[1-9]|1[0-2])[/]([0-9]{2})$')
  return reg.test(value.toLowerCase())
}

window.dbs = window.dbs || {}
dbs.form = dbs.form || {}

dbs.form.genericForm = function () {
  const self = this

  self.scrollToErrors = function () {
    // If modal is visible, do not scroll
    if ($('.modal.visible').length) return

    setTimeout(function () {
      const HEADER_HEIGHT_OFFSET = 120

      let errorMessage = self.el.find('.ui.error.message:not(:empty)')
      if (errorMessage.length) {
        $('html, body').animate({
          scrollTop: errorMessage.offset().top - HEADER_HEIGHT_OFFSET,
        })

        return
      }

      let fieldErrors = self.el.find('.field.error')
      if (fieldErrors.length) {
        $('html, body').animate({
          scrollTop: fieldErrors.first().offset().top - HEADER_HEIGHT_OFFSET,
        })
      }
    }, 100)
  }

  self.init = function (el) {
    self.el = $(el)
    self.submitButton = self.el.find('input[type="submit"], .submit.button')
    self.fields = {}
    self.validateInline = false
    self.validateOn = 'submit'
    self.endpoint = self.el.attr('data-endpoint')
    self.method = 'POST'
    self.events = new dbs.events()
    self.clearOnSubmit = false
    self.validateOnLoad = false

    self.parseSettings()
    self.parseValidation()

    self.onSubmit = self.el.attr('onsubmit')

    if (self.onSubmit) {
      if (process.env.NODE_ENV === 'development') {
        console.log('onSubmit found')
      }

      if (!self.el.attr('data-retain-onsubmit') && self.el.attr('data-retain-onsubmit') !== 'on') {
        self.el.attr('onsubmit', '')
      }

      self.form = self.el.form({
        fields: self.fields,
        on: self.validateOn,
        inline: self.validateInline,
        onSuccess: function (event) {
          window.kentico.updatableFormHelper.submitForm(event)

          if (event.originalEvent !== undefined) {
            self.events.emit('Form:validation_success', null, true)
          }

          return false
        },
        onFailure: function () {
          self.scrollToErrors()
          return false
        },
      })
    } else {
      self.bindInputs()
      self.bindSubmit()
      self.form = self.el.form({
        fields: self.fields,
        on: self.validateOn,
        inline: self.validateInline,
      })
    }

    self.el.find('.int-phone').each(function (i, el) {
      $(el).data(
        'validator',
        intlTelInput($(el).get(0), {
          initialCountry: 'AU',
          nationalMode: true,
          preferredCountries: ['AU'],
          useFullscreenPopup:false,
          // For details about options, see: https://github.com/jackocnr/intl-tel-input#initialisation-options
          // utilsScript - path to file or URL
          utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.2.16/js/utils.min.js',
        }),
      )

      $(el).on('change', function () {
        self.handlePhoneChange(el)
      })

      $(el).on('keyup', function () {
        self.handlePhoneChange(el)
      })
    })

    self.el.find('input, select, textarea').keyup(function () {
      // Event fires on each keypress.
      if (self.isValid()) {
        self.submitButton.prop('disabled', false)
      } else {
        console.log('self.submitButton', self.submitButton)
        //self.submitButton.prop('disabled', true)
      }
    })

    self.el.find('input, select, textarea').on('change', function () {
      // Event fies when element looses focus and a change occurred.
      if (
        $(this).attr('name').indexOf('PreferredCheckIndate') > -1 &&
        $('input[name*="PreferredCheckOutDate"]').length &&
        $(this).val() > $('input[name*="PreferredCheckOutDate"]').val()
      ) {
        $('input[name*="PreferredCheckOutDate"]').val($(this).val())
      }

      if (
        $(this).attr('name').indexOf('BroomeRebookCampaign') > -1 &&
        $(this).attr('name').indexOf('dtArrivalDate') > -1 &&
        $('input[name*="dtDepartureDate"]').length &&
        $(this).val() > $('input[name*="dtDepartureDate"]').val()
      ) {
        $('input[name*="dtDepartureDate"]').val($(this).val())
      }

      if (self.isValid()) {
        self.submitButton.prop('disabled', false)
      } else {
        console.log('self.submitButton', self.submitButton)
        //self.submitButton.prop('disabled', true)
      }
    })

    self.el.find('.field-recaptcha .form-control').on('change', function () {})
    if (process.env.NODE_ENV === 'development') {
      console.table(self.fields)
    }

    self.handlePhoneChange = function (el) {
      const convertedNumber = $(el).data('validator').getNumber()
      console.log(convertedNumber)
      $(el).parents('.field').find('.converted-phone').val(convertedNumber)
    }

    if (self.validateOnLoad) {
      self.form.form('validate form')
    }

    self.el.find('.section-group-text-ta').on('keypress', function () {
      return false
    })
  }

  self.bindInputs = function () {
    self.el
      .find('input')
      .not('[type="submit"]')
      .on('keypress', function (e) {
        if (e.which === 13) {
          e.preventDefault()
          self.el.find('input[type="submit"]:first, .submit.button').trigger('click')
        }
      })
  }

  self.send = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Form: send')
    }

    // get the data
    const data = self.form.form('get values')

    // create a request
    const sendRequest = new dbs.request(self.endpoint, self.method)

    // subscribe to the send event
    sendRequest.events.subscribe('Request:send', function (data) {
      self.el.find('[type="submit"], .submit.button').addClass('loading').blur()

      self.events.emit(
        'Form:send',
        {
          data: data.data,
          endpoint: data.endpoint,
          method: data.method,
        },
        true,
      )
    })

    // subscribe to the send_finished event
    sendRequest.events.subscribe('Request:send_finished', function (data) {
      self.el.find('[type="submit"], .submit.button').removeClass('loading').blur()

      self.events.emit(
        'Form:send_finished',
        {
          data: data.data,
          endpoint: data.endpoint,
          method: data.method,
        },
        true,
      )
    })

    /* Handle Responses */

    // subscribe to the send_success event
    sendRequest.events.subscribe('Request:send_success', function (data) {
      // always clear the form
      if (self.clearOnSubmit) {
        self.form.form('reset')
      }
      // create a new response
      const response = new dbs.response(data.response, self.el)
      response.handle()

      self.events.emit(
        'Form:send_success',
        {
          data: data.data,
          endpoint: data.endpoint,
          method: data.method,
          response: data.response,
        },
        true,
      )
    })

    // subscribe to the send_error event
    sendRequest.events.subscribe('Request:send_error', function (data) {
      // create a new response
      const response = new dbs.response(data.response, self.el)
      response.handle()

      self.events.emit(
        'Form:send_error',
        {
          data: data.data,
          endpoint: data.endpoint,
          method: data.method,
          response: data.response,
        },
        true,
      )
    })

    // subscribe to the send_fail event
    sendRequest.events.subscribe('Request:send_fail', function (data) {
      const response = new dbs.response(data.response, self.el)
      response.handle()

      self.events.emit(
        'Form:send_fail',
        {
          data: data,
        },
        true,
      )
    })

    // send the request
    sendRequest.send(data)
  }

  self.getValues = function () {
    return self.form.form('get values')
  }

  self.submit = function (e) {
    if (self.form.form('is valid')) {
      self.events.emit(
        'Form:validation_success',
        {
          values: self.form.form('get values'),
          el: self.el,
        },
        true,
      )

      // hide responses
      self.el.find('.response-container').html('')

      // if there is an endpoint, prevent default and send
      if (self.el.attr('data-endpoint')) {
        if (process.env.NODE_ENV === 'development') {
          console.log('preventing default')
        }
        e.preventDefault()
        self.send()
      } else {
        // self.el.find('input[type="submit"]').addClass('loading').blur();
      }
    } else {
      e.preventDefault()

      self.events.emit(
        'Form:validation_fail',
        {
          values: self.form.form('get values'),
          el: self.el,
        },
        true,
      )

      self.scrollToErrors()
    }
  }

  self.bindSubmit = function () {
    self.submitButton.on('click', function (e) {
      if (!$(this).hasClass('loading')) {
        self.submit(e)
      } else {
        e.preventDefault()
      }
    })
  }

  self.parseSettings = function () {
    // data-validate-inline
    if (self.el.attr('data-validate-inline') !== undefined) {
      self.validateInline = true
    }
    // data-validate-on
    if (self.el.attr('data-validate-on') !== undefined) {
      self.validateOn = self.el.attr('data-validate-on')
    }
    // method
    if (self.el.attr('data-method') !== undefined) {
      self.method = self.el.attr('data-method')
    }
    // clearOnSubmit
    if (self.el.attr('data-clear') !== undefined) {
      self.clearOnSubmit = true
    }
    // validateOnLoad
    if (self.el.attr('data-validate-on-load') !== undefined) {
      self.validateOnLoad = true
    }
  }

  self.parseValidation = function () {
    self.el.find('[data-rules]').each(function (vi, vel) {
      let identifier = $(vel).attr('name')
      if ($(vel).attr('data-validate')) {
        identifier = $(vel).attr('data-validate')
      }
      self.fields[identifier] = {
        identifier: identifier,
        rules: [],
      }
      const rules = $(vel).attr('data-rules').split(',')
      let prompts = []
      if ($(vel).attr('data-prompts')) {
        prompts = $(vel).attr('data-prompts').split(',')
      }
      for (let r = 0; r < rules.length; r++) {
        self.fields[identifier].rules.push({
          type: rules[r],
        })
        if (prompts.length && prompts[r]) {
          self.fields[identifier].rules[r].prompt = prompts[r].split('[comma]').join(',')
        }
      }
    })
  }

  self.handleError = function (message) {
    self.el
      .find('.response-container')
      .append(
        '<div class="ui negative message"><i class="icon close"></i><div class="ui header">Error</div><p>' +
          message +
          '</p></div>',
      )
  }

  self.handleFail = function () {
    self.el
      .find('.response-container')
      .append(
        '<div class="ui negative message"><i class="icon close"></i><div class="ui header">Error</div><p>Sorry there was a problem on our end. Please try again.</p></div>',
      )
  }

  self.isValid = function() {
    let isValid = self.form.form('is valid')
    self.events.emit('Form:isValid', isValid, true)
    return isValid
  }
}

// Initiate generic forms
$('.generic-form').each(function (i, el) {
  let formEl = $(el)
  formEl.data('Form', new dbs.form.genericForm(intlTelInput))
  formEl.data('Form').init(el)
})

// For any forms that did not initiate before the document was ready
$(document).ready(function () {
  $('.generic-form').each(function (i, el) {
    let formEl = $(el)
    // Do not re-initiate forms already initiated
    if (formEl.data('Form')) {
      return
    }

    formEl.data('Form', new dbs.form.genericForm(intlTelInput))
    formEl.data('Form').init(el)
  })
})
